<template>
    <div>
        <PageTitle :title=" (teatro.hash != 'UHmERrsRV19JCGQMg7Is' ? 'Experiencias' : 'FUTSAL FEST') + ' para la temporada ' + lista_abonados.nombre"/>
        <FirstBanner/>

        <ListadoEventosImagen
            :eventos="events"
            :loading="loadingEvents"
        />

        <template v-if="events.length == 0 && !loadingEvents">
            <NoEvents/>
        </template>
    </div>
</template>

<script setup>
    import { useHead } from '@/composables/common/seo/useHead'
    import { useRouter } from '@/composables/common/router/useRouter'
    import store from '@/store'
    import { computed, ref, onMounted } from 'vue'
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import FirstBanner from '@/components/frontend/shared/FirstBanner';
    import NoEvents from '@/components/frontend/events/listado/NoEvents';
    import ListadoEventosImagen from '@/components/frontend/events/listado/ListadoEventosImagen';

    useHead('Eventos')

    const loadingEvents = ref(false);
    const router = useRouter();

    function getEventos() {
        let params = {
            filters : {
                experiencias: 1
            }
        };

        loadingEvents.value = true;
        store.dispatch('FRONT_EXPERIENCIAS_INDEX', params).catch(error => {
            router.push({name: "front.error", params: {error: "getEventos"}});
            console.log(error);
        }).finally(() => {
            loadingEvents.value = false;
        });
    }

    onMounted(() => {
        if(store.getters.getFrontExperiencias === null) {
            getEventos();
        }        
    });

    const teatro = computed(() => store.getters.getTeatro)
    const lista_abonados = computed(() => store.getters.getListaAbonados)
    const events = computed(() => {
        return store.getters.getFrontExperiencias?.data ? store.getters.getFrontExperiencias.data : [] 
    })

</script>